var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_677_68919)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4286 6.85742C15.7442 6.85742 16 7.11326 16 7.42885V12.0003C16 12.3159 15.7442 12.5717 15.4286 12.5717H10.8571C10.5415 12.5717 10.2857 12.3159 10.2857 12.0003C10.2857 11.6847 10.5415 11.4289 10.8571 11.4289H14.8571V7.42885C14.8571 7.11326 15.113 6.85742 15.4286 6.85742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.167368 3.59608C0.390524 3.37292 0.752333 3.37292 0.97549 3.59608L5.14286 7.76345L7.76737 5.13894L7.77143 5.13491C7.98506 4.92551 8.27228 4.80822 8.57143 4.80822C8.87057 4.80822 9.1578 4.92551 9.37143 5.13491L9.37549 5.13894L15.8326 11.5961C16.0558 11.8192 16.0558 12.181 15.8326 12.4042C15.6095 12.6274 15.2477 12.6274 15.0245 12.4042L8.57143 5.95112L5.94692 8.57563L5.94286 8.57965C5.72922 8.78905 5.442 8.90634 5.14286 8.90634C4.84371 8.90634 4.55649 8.78905 4.34286 8.57965L4.3388 8.57563L0.167368 4.4042C-0.0557892 4.18104 -0.0557892 3.81924 0.167368 3.59608Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_68919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartArrowDown);
export default __webpack_public_path__ + "static/media/chart-arrow-down.6843bd2b885ef73ceb532c04ab49f625.svg";
export { ForwardRef as ReactComponent };